import { Route, Routes } from "react-router-dom"

import { StyledDashboard } from "components/AppOnboarding"
import PersistentToken from "components/app/PersistentToken"
import Challenge from "components/challenges/Challenge"
import PublicChallenges from "components/challenges/PublicChallenges"
import Entry from "components/entry/Entry"
import Idea from "components/ideas"
import { Invitation } from "components/lib/Invitations/Invitation"
import UserUnsubscribe from "components/users/Unsubscribe"
import { useAppSelector } from "store"

import CustomPage from "./CustomPage"

const NonUserSwitch = () => {
  const user = useAppSelector((state) => state.user)
  const showLogin = useAppSelector((state) => state.auth.showLogin)
  const gettingUserError = useAppSelector((state) => state.auth.errorMessage)

  if (!user && (showLogin || !gettingUserError)) {
    return (
      <Routes>
        <Route path="unsubscribe" element={<UserUnsubscribe />} />
        <Route path="invitations" element={<StyledDashboard excludeWelcomeText content={<Invitation />} />} />
        <Route path="ideas/:id" element={<Idea />} />
        <Route
          path="challenges/public"
          element={<StyledDashboard fluid excludeWelcomeText content={<PublicChallenges />} />}
        />
        <Route path="challenges/:id/*" element={<Challenge />} />
        <Route
          path="join/:token"
          element={<StyledDashboard scrolling={false} excludeWelcomeText content={<PersistentToken />} />}
        />
        <Route path="custom-pages/:pageId" element={<CustomPage />} />
        <Route path="*" element={<Entry />} />
      </Routes>
    )
  }
  return null
}

export default NonUserSwitch
